import React from 'react'
import {isEmpty} from 'lodash'
import {Redirect} from 'react-router-dom'

import errors from '../../lib/errors.js'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'

import Resource from '../../stores/resource'
import DirectorNotFound from "./DirectorNotFound";
import DirectorCard from "./DirectorCard";
const DirectorStore = Resource('directors')

class ShowDirector extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      director: {},
      error: null,
      loading: true
    }
  }

  componentDidMount() {
    DirectorStore.findBy({id: this.props.match.params.id})
    .then((result) => this.setState({director: result.data, loading: false}))
    .catch((error) => this.setState({director: {}, error: errors.unpack(error), loading: false}))
  }

  _redirectTo = (url) => {
    this.setState({redirect: url})
  }

  render() {
    const {
      director,
      redirect,
      loading
    } = this.state

    if (loading) return <LinearLoader />
    if (redirect) return <Redirect push to={redirect}/>
    if (isEmpty(director)) return <DirectorNotFound/>

    return (
      <section>
        <header>
          <PageTitle>
            Director: <span className="mui--text-dark">{director.name}</span>
          </PageTitle>
        </header>
        <DirectorCard
          director={director}
          editCallback={() => this._redirectTo(`/directors/${director.id}/edit`)}
        />
        <br/>
        <BackButton/>
      </section>
    )
  }
}

export default ShowDirector



// WEBPACK FOOTER //
// ./src/components/Directors/ShowDirectorPage.jsx